import { useHttpClient } from "@/common/api/httpClient";
import type { ShapeResponse } from "./models/shapeResponse";
import { processShape } from "../domain/processShape";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";

export interface QueryShapeRequest {
  storageAreaId?: string;
}

export interface QueryShapeResponse {
  ok: true;
  shapes: ShapeResponse[];
}

export function useQueryShape() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: QueryShapeRequest) {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`shape/query`), {
      headers,
      method: 'post',
      body: JSON.stringify(action)
    });

    const text = translations.value.shapes.actions.query;

    const response = await httpClient.action<QueryShapeResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const shapes = await response.json() as ShapeResponse[];
        for (const shape of shapes) {
          processShape(shape);
        }
        return {
          ok: true,
          shapes: shapes
        };
      },
    });

    return response;
  }
}
